// extracted by mini-css-extract-plugin
module.exports = {"form_container":"style_form_container__29YoH","buttons_container":"style_buttons_container__wNLAl","button":"style_button__2POda"};